import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  fallbackLng: "ru",
  lng: localStorage.getItem("lang"),
  resources: {
    ru: {
      translations: require("./locales/ru/translations.json"),
    },
    en: {
      translations: require("./locales/en/translations.json"),
    },
    uz: {
      translations: require("./locales/uz/translations.json"),
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
});

i18n.languages = ["ru", "en"];

export default i18n;
